import React, { useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import PageHero from "../components/PageHero";
import { resourceItems, siteMeta } from "../data/siteContent";

function ResourcesPage() {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");

  const categories = ["All", ...new Set(resourceItems.map((item) => item.category))];

  const filteredResources = useMemo(() => {
    return resourceItems.filter((item) => {
      const query = search.toLowerCase();
      const matchesSearch =
        !query ||
        item.title.toLowerCase().includes(query) ||
        item.excerpt.toLowerCase().includes(query) ||
        item.language.toLowerCase().includes(query);
      const matchesCategory = category === "All" || item.category === category;
      return matchesSearch && matchesCategory;
    });
  }, [search, category]);

  return (
    <>
      <PageHero
        eyebrow="Resources"
        title="Resources for Growing in Christ"
        intro="Explore articles, Bible studies, doctrine notes, and language-specific resources designed to help believers grow in truth and grace."
        metaTitle={`Resources | ${siteMeta.churchName}`}
      />
      <section className="site-section">
        <Container>
          <div className="filters-panel">
            <input
              type="search"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Search resources"
            />
            <select value={category} onChange={(event) => setCategory(event.target.value)}>
              {categories.map((item) => (
                <option key={item} value={item}>
                  Category: {item}
                </option>
              ))}
            </select>
          </div>
          {filteredResources.length ? (
            <Row className="g-4">
              {filteredResources.map((item) => (
                <Col md={6} xl={4} key={item.title}>
                  <article className="resource-card h-100">
                    <span>{item.category}</span>
                    <h2>{item.title}</h2>
                    <p>{item.excerpt}</p>
                    <small>{item.language}</small>
                  </article>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="empty-state">
              <h2>No resources found</h2>
              <p>Try a different category or search term.</p>
            </div>
          )}
        </Container>
      </section>
    </>
  );
}

export default ResourcesPage;
